import React from 'react';
import {useLocale} from '../../Localization/LocaleContext';

const PrimaryButton = ({children, onClick}) => {
  const {translate} = useLocale();
  const label = typeof children === 'string' ? translate(children) : children;
  return (
    <button
      onClick={onClick}
      className="px-4 py-2 bg-primary text-white border border-primary hover:text-primary  hover:bg-transparent duration-500 rounded-md  ">
      {label}
    </button>
  );
};

export default PrimaryButton;
